import Path from "@core/FileProvider/Path/Path";
import type GithubStorageData from "@ext/git/actions/Source/GitHub/model/GithubStorageData";
import type GitStorageData from "@ext/git/core/model/GitStorageData";
import SourceType from "@ext/storage/logic/SourceDataProvider/model/SourceType";

/**
 * What `storage/init` gets for the open catalog. A provider creates the repository on the first push, so the
 * form picks a group and the repository is named after the catalog. A plain Git server creates nothing: the
 * link names a repository made beforehand, and it is used as it is.
 */
export const getInitStorageData = (data: GitStorageData, catalogName: string): GitStorageData => {
	if (data.source.sourceType === SourceType.git) return { source: data.source, group: data.group, name: data.name };

	const isGithub = data.source.sourceType === SourceType.gitHub;
	const additional = isGithub ? { type: (data as GithubStorageData).type } : {};
	return { source: data.source, group: Path.join(data.group, data.name), name: catalogName, ...additional };
};
